<div class="space-y-6">

  <!-- Header -->
  <div class="flex justify-between items-center mb-6">
    <div>
      <h2 class="text-2xl font-semibold text-gray-800">Services Catalog</h2>
      <p class="text-sm text-gray-500 mt-1">Manage the different mechanic services offered on the platform.</p>
    </div>
    <div class="flex gap-3">
      <button
        (click)="loadServices()"
        class="flex items-center gap-2 px-4 py-2 bg-gray-100 text-gray-700 text-sm rounded-lg hover:bg-gray-200 transition">
        Refresh
      </button>
      <button
        (click)="openCreateModal()"
        class="flex items-center gap-2 px-4 py-2 bg-blue-600 text-white text-sm rounded-lg hover:bg-blue-700 transition">
        + Create Service
      </button>
    </div>
  </div>

  <!-- Loading Spinner -->
  <div *ngIf="isLoading" class="flex justify-center items-center py-20">
    <div class="w-10 h-10 border-4 border-blue-500 border-t-transparent rounded-full animate-spin"></div>
  </div>

  <!-- Error State -->
  <div *ngIf="!isLoading && errorMessage" class="flex items-center gap-3 bg-red-50 border border-red-200 text-red-700 px-4 py-3 rounded-lg mb-6">
    <span>{{ errorMessage }}</span>
    <button (click)="loadServices()" class="ml-auto text-sm underline">Retry</button>
  </div>

  <!-- Data Grid -->
  <div *ngIf="!isLoading && !errorMessage" class="bg-white rounded-2xl shadow overflow-hidden">
    <table class="w-full text-sm">
      <thead class="bg-gray-100 text-left">
        <tr>
          <th class="p-4 w-1/4">Name</th>
          <th>Category</th>
          <th>Price</th>
          <th>Duration</th>
          <th>Status</th>
          <th>Actions</th>
        </tr>
      </thead>
      <tbody>
        <tr *ngFor="let service of servicesList" class="border-t hover:bg-gray-50">
          <td class="p-4">
            <p class="font-medium text-gray-800">{{ service.name }}</p>
            <p class="text-xs text-gray-500 truncate max-w-[200px]">{{ service.description }}</p>
          </td>
          <td class="text-gray-600">{{ service.category }}</td>
          <td class="font-medium text-gray-800">${{ service.base_price | number:'1.2-2' }}</td>
          <td class="text-gray-600">{{ service.estimated_duration_minutes }} mins</td>
          <td>
            <span [class]="service.is_active ? 'bg-green-100 text-green-800' : 'bg-gray-100 text-gray-800'" class="px-2 py-1 rounded-full text-xs font-medium">
              {{ service.is_active ? 'Active' : 'Inactive' }}
            </span>
          </td>
          <td>
             <div class="flex items-center gap-3">
                <button (click)="openEditModal(service)" class="text-blue-600 hover:underline">Edit</button>
                <button (click)="deleteService(service.id)" class="text-red-600 hover:underline">Delete</button>
             </div>
          </td>
        </tr>
        <tr *ngIf="servicesList.length === 0">
          <td colspan="6" class="p-8 text-center text-gray-500">No services available.</td>
        </tr>
      </tbody>
    </table>
  </div>

</div>

<!-- Modal Form -->
<app-modal [isOpen]="isModalOpen" (close)="isModalOpen = false" className="max-w-2xl">
    <app-service-form 
        *ngIf="isModalOpen"
        [serviceData]="selectedService" 
        (save)="handleSave($event)" 
        (cancel)="isModalOpen = false">
    </app-service-form>
</app-modal>
